import { useCallback } from 'react';
import { useTranslation } from '@aimsos/i18n';

import { validateApiResponse } from '../../../services';
import { getImportCatalog } from '../../../services/importService.js';

/**
 * Loader of what the review step checks the file against (roles, groups, existing members and
 * the workspace domain). The envelope is validated here, so the wizard only sees the body.
 *
 * @returns {{ loadCatalog: () => Promise<object> }}
 */
export const useImportCatalog = () => {
  const { t } = useTranslation('people-access');
  const loadCatalog = useCallback(async () => {
    const res = await getImportCatalog();
    return validateApiResponse(res, t('import.review.loadError')).body;
  }, [t]);
  return { loadCatalog };
};
